import { API, fetchEventStream } from 'utils/globalApiServices';

export async function askQuestionService({ prompt, session_id }) {
  const url = `/ai-integration/chat-assistant/ask`;
  const data = await API.post(url, { prompt, session_id });
  return data;
}

const allowedTags = [
  'div',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'b',
  'i',
  'u',
  'strong',
  'a',
  'em',
  'mark',
  'ul',
  'ol',
  'li',
  'br',
  'hr',
  'code',
  'img',
  'q',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
  'blockquote',
  'cite',
];

const cleanMarkdown = (text) => {
  let cleaned = text;

  cleaned = cleaned.replace(/<\/?([a-zA-Z0-9_]+)(?:\s[^>]*)?>/g, (match, tagName) => {
    if (allowedTags.includes(tagName.toLowerCase())) return match;
    return '';
  });

  cleaned = cleaned.replace(
    /<([a-zA-Z0-9_]+)(?:\s[^>]*)?>([\s\S]*?)<\/\1>/g,
    (match, tagName, innerContent) => {
      if (allowedTags.includes(tagName.toLowerCase())) return match;
      return innerContent;
    }
  );

  cleaned = cleaned.replace(/<([a-zA-Z0-9_]+)(?:\s[^>]*)?\/>/g, (match, tagName) => {
    if (allowedTags.includes(tagName.toLowerCase())) return match;
    return '';
  });

  return cleaned;
};

/** This function is responsible for processing the real-time response (streaming) from the endpoint. */
export async function askQuestionsListenEvents({
  org_id,
  question,
  session_id,
  onMessage, // callback that is called for each fragment received.
  onError, //callback for errors
  onComplete, //callback when the stream ends.
  onLoading, // callback when it finishes making the request and starts receiving fragments
  onSaveId, //callback to update the id of the question context
}) {
  const body = session_id === '' ? { question } : { question, session_id };
  try {
    const response = await fetchEventStream({ body, org_id }); //makes the HTTP request

    const reader = response.body.getReader(); //Allows to read chuck by chuck(fragment)
    const decoder = new TextDecoder('utf-8'); //converts bytes to text.
    let buffer = ''; //accumulates partial text until it can be split correctly.
    let emptyLineStreak = 0; // contador de líneas vacías seguidas

    while (true) {
      //Infinite loop that reads the stream until done is true (end of stream).
      const { done, value } = await reader.read(); //value is a Uint8Array with the data.
      if (done) break;

      buffer += decoder.decode(value, { stream: true }); //The chunk is decoded and added to the buffer.

      const lines = buffer.split('\n'); //Then it is divided by lines
      buffer = lines.pop() || ''; //The last line may be incomplete. It will be saved for the next cycle.

      for (const line of lines) {
        //Every line of the stream is checked.
        const lineStream = line.trim();

        if (lineStream === '') {
          emptyLineStreak++;
          if (emptyLineStreak >= 2) {
            onMessage('\n');
            emptyLineStreak = 0;
          }
          continue;
        } else {
          emptyLineStreak = 0;
        }

        if (lineStream === '---' || lineStream === '***' || lineStream === '___') {
          //Markdown syntax for a horizontal line that sometimes arrives without data:
          onMessage(`\n${lineStream}\n`);
          continue;
        }

        if (lineStream.includes('Error:')) {
          //Error sent directly from backend
          await reader.cancel();
          onError?.();
          onLoading?.();
          return;
        }

        if (lineStream.startsWith('data:')) {
          //Only those that begin with "data:"" will be processed::
          const data = lineStream.slice(5).trim(); //remove "data:" and spaces

          if (data.includes('SESSION_ID:')) {
            // save/update session_id and set loading in false
            onSaveId(data.split('::')[1]);
            onLoading?.();
            continue;
          }

          if (data === 'end connection') {
            //finish connection
            await reader.cancel();
            onComplete?.();
            return;
          }

          const cleanedData = cleanMarkdown(data);
          if (cleanedData) onMessage(`${cleanedData}\n`);
          continue;
        }
        const cleanedLine = cleanMarkdown(lineStream);
        if (cleanedLine) onMessage(`${cleanedLine}\n`);
      }
    }
  } catch (err) {
    //If there is a general error (network, parding, etc.) call onError
    if (onError) {
      onError(err);
      onLoading?.();
    }
  }
}
